import React from 'react';
import { createAlyzeOptimizedImageUrl } from './AlyzeOptimizedImageUrl.ts';

interface AlyzeOptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  sizes?: string;
  style?: React.CSSProperties;
  loading?: 'lazy' | 'eager';
}

export const AlyzeOptimizedImage: React.FC<AlyzeOptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  className,
  sizes,
  style,
  loading = 'lazy'
}) => {
  // Check if it's an SVG file
  const isSvg = src.toLowerCase().endsWith('.svg');
  
  if (isSvg) {
    // For SVG files, use them directly without optimization
    return (
      <img 
        src={createAlyzeOptimizedImageUrl({ key: src })}
        alt={alt}
        width={width}
        height={height}
        className={className}
        sizes={sizes}
        loading={loading}
        style={style}
      />
    );
  }
  
  // Create WebP version for modern browsers
  const webpSrc = createAlyzeOptimizedImageUrl({
    key: src,
    width,
    height,
    format: 'webp',
    quality: 80
  });
  
  // Create JPEG fallback
  const jpegSrc = createAlyzeOptimizedImageUrl({
    key: src,
    width,
    height,
    format: 'jpeg',
    quality: 80
  });
  
  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img 
        src={jpegSrc}
        alt={alt}
        width={width}
        height={height}
        className={className}
        sizes={sizes}
        loading={loading}
        style={style}
      />
    </picture>
  );
};
